// extracted by mini-css-extract-plugin
export default {"backdrop":"styles_backdrop__wOw5y","modal":"styles_modal__BYLoV","close":"styles_close__TVmzE","icon":"styles_icon__eUdB9"};